import { AnimatePresence, motion } from "framer-motion";
import React, { useEffect, useRef, useState } from "react";

import { cn } from "../../handlers/cn.utils";

function DetailedTooltip({ children, content, position = "bottom", className = "" }) {
	const contentRef = useRef(null);
	const [visible, setVisible] = useState(false);

	const getPositionStyles = () => {
		switch (position) {
			case "top":
				return "bottom-full mb-2";
			case "bottom":
				return "top-full mt-2";
			case "left":
				return "right-full mr-2";
			case "right":
				return "left-full ml-2 -top-1/2";
			default:
				return "top-full mt-2";
		}
	};

	const getTriangleStyles = () => {
		switch (position) {
			case "top":
				return "bottom-[-12px] left-1/2 -translate-x-1/2 border-l-transparent border-r-transparent border-t-[#E8F4FF] border-b-0";
			case "bottom":
				return "top-[-12px] right-2 -translate-x-1/2 border-l-transparent border-r-transparent border-b-[#E8F4FF] border-t-0";
			case "left":
				return "right-[-12px] top-1/2 -translate-y-1/2 border-t-transparent border-b-transparent border-l-[#E8F4FF] border-r-0";
			case "right":
				return "left-[-12px] top-1/2 -translate-y-1/2 border-t-transparent border-b-transparent border-r-[#E8F4FF] border-l-0";
			default:
				return "top-[-12px] left-1/2 -translate-x-1/2 border-l-transparent border-r-transparent border-b-[#E8F4FF] border-t-0";
		}
	};

	useEffect(() => {
		if (contentRef.current) {
			const contentRect = contentRef.current.getBoundingClientRect();
			const windowWidth = window.innerWidth;
			const windowHeight = window.innerHeight;

			if (contentRect.right > windowWidth) {
				contentRef.current.style.right = "0";
				contentRef.current.style.left = "auto";
			}

			if (contentRect.left < 0) {
				contentRef.current.style.left = "0";
				contentRef.current.style.right = "auto";
			}

			if (contentRect.top < 0) {
				contentRef.current.style.top = "0";
				contentRef.current.style.bottom = "auto";
			}

			if (contentRect.bottom > windowHeight) {
				contentRef.current.style.bottom = "0";
				contentRef.current.style.top = "auto";
			}
		}
	}, [contentRef, visible]);

	return (
		<div
			className={cn("relative", className)}
			onMouseEnter={() => {
				// if mouse enters tooltip, and stays for more than 1 second, show tooltip
				setTimeout(setVisible(true), 1000);
			}}
			onMouseLeave={() => setTimeout(setVisible(false), 1000)}
		>
			{children}

			<AnimatePresence>
				{visible && (
					<motion.div
						ref={contentRef}
						className={`absolute ${getPositionStyles()} w-fit text-nowrap bg-[#E8F4FF] rounded-md shadow-sm`}
						initial={{ scale: 0.8, opacity: 0 }}
						animate={{ scale: 1, opacity: 1 }}
						exit={{ scale: 0.8, opacity: 0 }}
						transition={{ duration: 0.2 }}
					>
						{content}
						<div className={`absolute w-3 h-3 border-4 ${getTriangleStyles()}`} />
					</motion.div>
				)}
			</AnimatePresence>
		</div>
	);
}

export default DetailedTooltip;
